//
// Copyright (c) 2011-2024 by Curalate, Inc
//

import React from 'react';
import styled from 'styled-components';

import Icon from '@components/atoms/icon/Icon';
import { BodyText } from '@components/atoms/text/Text';
import {
  FilterOption,
  FilterValue,
} from '@components/media-filters/filterSectionModels';

export interface SelectedOptionProps<T extends FilterValue> {
  isDisabled?: boolean;
  option: FilterOption<T>;
  onDeselect: () => void;
}

export const SelectedOption = <T extends FilterValue>({
  isDisabled,
  option,
  onDeselect,
}: SelectedOptionProps<T>) => (
  <OptionBox>
    <BodyText ellipsize={1} title={option.label}>
      {option.label}
    </BodyText>
    {!isDisabled && (
      <CloseIconButton onClick={onDeselect} type='button'>
        <CloseIcon name='close' />
      </CloseIconButton>
    )}
  </OptionBox>
);

const OptionBox = styled.div`
  display: flex;
  justify-content: space-between;
`;

const CloseIconButton = styled.button`
  cursor: pointer;
  border: unset;
  background: unset;
`;

const CloseIcon = styled(Icon)(
  ({ theme }) => `
    color: ${theme.colors.red8};
  `,
);
